import { render, staticRenderFns } from "./TemplateMarketItem.vue?vue&type=template&id=96580142&scoped=true"
import script from "./TemplateMarketItem.vue?vue&type=script&lang=js"
export * from "./TemplateMarketItem.vue?vue&type=script&lang=js"
import style0 from "./TemplateMarketItem.vue?vue&type=style&index=0&id=96580142&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96580142",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96580142')) {
      api.createRecord('96580142', component.options)
    } else {
      api.reload('96580142', component.options)
    }
    module.hot.accept("./TemplateMarketItem.vue?vue&type=template&id=96580142&scoped=true", function () {
      api.rerender('96580142', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/panel/templateMarket/component/TemplateMarketItem.vue"
export default component.exports